import React from 'react'

export default function FinancialPlanning() {
    return (
        <div>
            <p>
                As a Financial Planner, my role is to put together an action plan that incorporates your 
                goals and objectives with sound recommendations. My greatest value to you is to help you 
                manage your money and investing behavior. 
            </p>
            <p>
                It is a common belief that during times of stress and fear, we are going to behave rationally 
                when people frequently behave irrationally. We know with certainty, that there will always be 
                periods of uncertainty, and we can help you prepare them.
            </p>
            <p>
                Our goal is to put together a financial plan so that when you need money, for whatever the reason, 
                there is a smart place to get it—a place where you can rely on it being there when you need it. 
            </p>
            <h5 className='title_h5'>Our process includes Financial Planning for all aspects of life…</h5>
            <ul>
                <li> Help establish your Goals and Objective </li>
                <li> Review Cashflow and Debt </li>
                <li> Risk Management and Insurance Products </li>
                <li> Portfolio Design and Investment Management </li>
                <li> Retirement Income Planning </li>
                <li> Tax Planning: employing strategies to minimize taxes </li>
                <li> Education Planning </li>
                <li> Estate Planning </li>
                <li> Business Planning </li>
            </ul>
            <h3 className='title_h3'>RETIREMENT PLANNING</h3>
            <h5 className='title_h5'>For most people, planning for retirement is their largest financial goal and requires careful planning. 
                There is no cookie cutter solution, as everyone has a different set of circumstances, goals and resources. 
            </h5>
            <p>
                Whether you are far from retirement, nearing retirement or retired, you likely have questions about financial 
                planning for retirement. Understanding the importance of investment management; cash flow; budgeting; and risk 
                management is critical to achieving financial success in retirement. 
            </p>
            <h5 className='title_h5'>Some common questions people have about planning for retirement…</h5>

            <ul>
                <li> When will you be able to retire? </li>
                <li> How are tracking financially toward the retirement you envision? </li>
                <li> How much should you be saving for retirement? </li>
                <li> What investment return do you need to achieve your goals? </li>
                <li> Is your current investment strategy aligned with your goals? </li>
                <li> How much investment risk are you taking? How much are you willing to take? </li>
                <li> What impact does a career transition have on my retirement? </li>
                <li> How can I make sure my money will last through my retirement years? </li>
                <li> What will be my Retirement Income sources and how can I maximize them? </li>
                <li> How will inflation, health care and long-term care expenses effect my retirement. </li>
                <li> Should I convert some of my IRA to a Roth IRA? </li>
            </ul>
            <p>
                Our many years of experience, coupled with modern financial planning technology, enables us to assess and 
                understand your circumstances. By providing you with valuable information and a fresh perspective about the 
                decisions you need to make, we can help you evaluate the choices you are facing and discuss the pros and cons of each. 
            </p>
        </div>
    )
}